import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Dropdown,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { bankAccountDeleteStart, bankAccountListStart, bankAccountStatusUpdateStart } from "../../store/slices/WithdrawSlice";
import Skeleton from "react-loading-skeleton";
import { ButtonLoader } from "../Helper/Loader";
import NoDataFound from "../Helper/NoDataFound";
import { useTranslation } from "react-multi-lang";
import AddBankModal from "./AddBankModal";
import Pagination from "../Helper/Pagination";
import { Field, Form as FORM, Formik } from "formik";
import ViewBankAccountModal from "./ViewBankAccountModal";

const BankAccountIndex = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const t = useTranslation("bank_index");
  const profile = useSelector((state) => state.admin.profile);
  const bankAccountList = useSelector((state) => state.withdraw.bankAccountList);
  const bankAccountSave = useSelector((state) => state.withdraw.bankAccountSave);
  const bankAccountDelete = useSelector((state) => state.withdraw.bankAccountDelete);
  const bankAccountStatusUpdate = useSelector((state) => state.withdraw.bankAccountStatusUpdate);
  const [searchParams] = useSearchParams();
  const [skipRender, setSkipRender] = useState(true);
  const [filter, setFilter] = useState({
    search_key: searchParams.get("search_key") ? searchParams.get("search_key") : "",
  });
  const [page, setPage] = useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 1
  );
  const [addBank, setAddBankModal] = useState(false);
  const [viewAccount, setViewAccount] = useState(null);
  const [renderPage, setRenderPage] = useState(false);
  const confirmDeleteMessage = t("delete_confirm");

  useEffect(() => {
    if (!profile.loading && Object.keys(profile.data).length > 0) {
      dispatch(
        bankAccountListStart({
          ...filter,
          skip: 12 * (page - 1),
          take: 12,
        })
      );
    }
  }, [profile, filter, page, renderPage]);

  useEffect(() => {
    if (!skipRender) {
      setPage(searchParams.get("page") ? Number(searchParams.get("page")) : 1);
      setFilter((prev) => ({
        ...prev,
        search_key: searchParams.get("search_key")
          ? searchParams.get("search_key")
          : "",
      }));
    }
    setSkipRender(false);
  }, [searchParams]);

  useEffect(() => {
    if (
      !bankAccountSave.loading &&
      Object.keys(bankAccountSave.data).length > 0 &&
      addBank
    ) {
      setAddBankModal(false);
      setSkipRender(true);
      setRenderPage(! renderPage);
    }
  }, [bankAccountSave]);

  const handlePageClick = ({ selected }) => {
    const params = searchParams.get("search_key")
      ? `search_key=${searchParams.get("search_key")}&`
      : "";
    navigate(`/bank-accounts?${params}page=${selected + 1}`);
  };

  return (
    <>
      <div className="payment-link-sec">
        <div className="payment-link-box">
          <div className="payment-link-header-sec">
            <div className="create-payment-link-header-sec">
              <h3>{t("heading")} {!bankAccountList.loading ? `(${bankAccountList.data.total_bank_accounts})` : null}</h3>
            </div>
            <div className="transactions-list-filter-sec">
              <div className="header-search">
                <Formik
                  initialValues={{
                    search_key: searchParams.get("search_key")
                      ? searchParams.get("search_key")
                      : "",
                  }}
                  enableReinitialize
                  onSubmit={(val) => {
                    setFilter((prev) => ({
                      ...prev,
                      search_key: val.search_key,
                    }));
                    navigate(
                      val.search_key ? `/bank-accounts?search_key=${val.search_key}` : "/bank-accounts"
                    );
                  }}
                >
                  {({ setFieldValue }) => (
                    <FORM className="form" style={{ display: "flex", gap: "1em" }}>
                      <InputGroup className="mb-0">
                        <Field
                          placeholder="Search"
                          type="text"
                          className="form-control"
                          name="search_key" />
                        {searchParams.get("search_key") && (
                          <InputGroup.Text id="basic-addon2">
                            <button
                              type="button"
                              className="search-btn"
                              onClick={() => {
                                setFieldValue("search_key", "");
                                setFilter((prev) => ({ ...prev, search_key: "" }));
                                navigate("/bank-accounts");
                              }}
                            >
                              <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                            </button>
                          </InputGroup.Text>
                        )}
                        <InputGroup.Text id="basic-addon2">
                          <button className="search-btn" type="submit">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              fill="#3E4351"
                              x="0"
                              y="0"
                              enableBackground="new 0 0 513.749 513.749"
                              version="1.1"
                              viewBox="0 0 513.749 513.749"
                              xmlSpace="preserve"
                            >
                              <path d="M504.352 459.061l-99.435-99.477c74.402-99.427 54.115-240.344-45.312-314.746S119.261-9.277 44.859 90.15-9.256 330.494 90.171 404.896c79.868 59.766 189.565 59.766 269.434 0l99.477 99.477c12.501 12.501 32.769 12.501 45.269 0 12.501-12.501 12.501-32.769 0-45.269l.001-.043zm-278.635-73.365c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160c-.094 88.326-71.673 159.906-160 160z"></path>
                            </svg>
                          </button>
                        </InputGroup.Text>
                      </InputGroup>
                    </FORM>
                  )}
                </Formik>
              </div>
              <Button
                type="button"
                className="snapgopay-payment-btn"
                onClick={() => setAddBankModal(true)}
              >
                {t("add_bank_account")}
              </Button>
            </div>
          </div>
          <div className="recent-transaction-table-sec table-responsive">
            <React.Fragment>
              <Table>
                <thead>
                  <tr>
                    <th>{t('s_no')}</th>
                    <th>{t('account_holder_name')}</th>
                    <th>{t('ifsc_code')}</th>
                    <th>{t('account_number')}</th>
                    <th>{t('bank_name')}</th>
                    <th>{t('account_type')}</th>
                    <th>{t('created_at')}</th>
                    <th>{t('actions')}</th>
                  </tr>
                </thead>
                <tbody>
                  {bankAccountList.loading ? (
                    [...Array(5)].map((_, key) => (
                      <tr key={key}>
                        {[...Array(8)].map((__, idx) => (
                          <td key={idx}>
                            <Skeleton height={20} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : Object.keys(bankAccountList.data).length > 0 &&
                    bankAccountList.data.bank_accounts.length > 0 ? (
                    bankAccountList.data.bank_accounts.map((account, i) => {
                      const isUpdatingDefault = bankAccountStatusUpdate.buttonDisable &&
                        bankAccountStatusUpdate.data?.bank_account_id === account.id;
                      const isDeletingAccount = bankAccountDelete.buttonDisable &&
                        bankAccountDelete.data?.bank_account_id === account.id;

                      return (
                        <tr key={account.id || i}>
                          <td>{(page - 1) * 12 + (i + 1)}</td>
                          <td>
                            {account.account_holder_name}
                            {account.is_default ? (
                              <span className="ms-2 badge bg-primary">Default</span>
                            ) : null}
                          </td>
                          <td>{account.ifsc_code}</td>
                          <td>{account.account_number}</td>
                          <td>{account.bank_name}</td>
                          <td>
                            {account.account_type
                              ? `${account.account_type.charAt(0).toUpperCase()}${account.account_type.slice(1)} Account`
                              : "-"}
                          </td>
                          <td>{account.created_at || "-"}</td>
                          <td>
                            <div className="payment-link-dropdown">
                              <Dropdown>
                                <div className="payment-link-icon-sec">
                                  <Dropdown.Toggle id="dropdown-basic">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      x="0"
                                      y="0"
                                      enableBackground="new 0 0 512 512"
                                      version="1.1"
                                      viewBox="0 0 512 512"
                                      xmlSpace="preserve"
                                    >
                                      <circle
                                        cx="458.667"
                                        cy="256"
                                        r="53.333"
                                      ></circle>
                                      <circle
                                        cx="256"
                                        cy="256"
                                        r="53.333"
                                      ></circle>
                                      <circle
                                        cx="53.333"
                                        cy="256"
                                        r="53.333"
                                      ></circle>
                                    </svg>
                                  </Dropdown.Toggle>
                                </div>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => setViewAccount(account)}
                                  >
                                    <span>{t("view")}</span>
                                  </Dropdown.Item>
                                  <Dropdown.Item as={Link} to={`/bank-accounts/create/${account.id}`}>
                                    <span>{t("edit")}</span>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    disabled={bankAccountDelete.buttonDisable}
                                    onClick={() => {
                                      if (window.confirm(confirmDeleteMessage)) {
                                        dispatch(bankAccountDeleteStart({ bank_account_id: account.id }));
                                        setRenderPage(! renderPage);
                                      }
                                    }}
                                  >
                                    {isDeletingAccount ? <ButtonLoader /> : <span>Delete</span>}
                                  </Dropdown.Item>
                                  {!account.is_default && (
                                    <Dropdown.Item
                                      disabled={bankAccountStatusUpdate.buttonDisable}
                                      onClick={() => dispatch(bankAccountStatusUpdateStart({ bank_account_id: account.id }))}
                                    >
                                      {isUpdatingDefault ? <ButtonLoader /> : <span>{t("set_as_default_account")}</span>}
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <NoDataFound />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {!bankAccountList.loading &&
                Object.keys(bankAccountList.data).length > 0 &&
                bankAccountList.data.bank_accounts.length > 0 ? (
                <div className="new-billings-pagination-sec">
                  <Pagination
                    page={page}
                    handlePageClick={handlePageClick}
                    pageCount={Math.ceil(
                      (bankAccountList.data.total_bank_accounts || 0) / 12
                    )}
                  />
                </div>
              ) : null}
            </React.Fragment>
          </div>
        </div>
      </div>
      {addBank && (
        <AddBankModal
          onHide={() => setAddBankModal(false)}
          setAddBankModal={setAddBankModal}
          show={addBank}
        // onHide={() => setModalShow(false)}
        />
      )}
      {viewAccount && (
        <ViewBankAccountModal
          account={viewAccount}
          show={!!viewAccount}
          onHide={() => setViewAccount(null)}
        />
      )}
      <div className="bank-account-sec" style={{ display: "none" }}>
        <div className="settlement-top-sec">
          <h3>{t("heading")}</h3>
          <div
            // to="/bank-accounts/create"
            type="button"
            className="snapgopay-payment-btn"
            onClick={() => setAddBankModal(true)}
          >
            {t("add_bank_account")}
          </div>
        </div>
        <div className="bank-account-list-box">
          {bankAccountList.loading ? (
            [...Array(3)].map((i, key) => <Skeleton key={key} height={220} />)
          ) : Object.keys(bankAccountList.data).length > 0 ? (
            <React.Fragment>
              {bankAccountList.data.bank_accounts.length > 0
                ? bankAccountList.data.bank_accounts.map((account, i) => (
                  <div className={`bank-account-list-card ${account.is_default ? "bank-account-list-primary-card" : ""}`} key={i}>
                    <div className="bank-account-list-item">
                      <div className="bank-account-list-header-sec">
                        <div className="bank-account-list-header-left-sec">
                          <h4>{account.account_holder_name}</h4>
                          <p>{account.bank_name.toUpperCase()}</p>
                        </div>
                        <div className="bank-account-list-header-right-sec">
                          {!account.is_default &&
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip">
                                  <strong>{t("set_as_default_account")}</strong>{" "}
                                </Tooltip>
                              }>
                              <Button className="make-primary-btn"
                                onClick={() => dispatch(bankAccountStatusUpdateStart({ bank_account_id: account.id }))}
                                disabled={bankAccountStatusUpdate.buttonDisable}
                              >
                                {bankAccountStatusUpdate.buttonDisable && (account.id === bankAccountStatusUpdate.data.bank_account_id) ? <ButtonLoader /> : <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  fill="none"
                                  viewBox="0 0 22 16"
                                >
                                  <path
                                    fill="#FFB743"
                                    d="M1.971 11.422L.717 3.267a.68.68 0 011.08-.648l3.909 2.932a.934.934 0 001.338-.23l3.254-4.88a.869.869 0 011.445 0l3.255 4.88a.934.934 0 001.337.23l3.909-2.932a.68.68 0 011.08.648l-1.254 8.155H1.97zM19.126 15.947H2.914a.944.944 0 01-.943-.944V12.93H20.07v2.073a.944.944 0 01-.944.944z"
                                  ></path>
                                </svg>}
                              </Button>
                            </OverlayTrigger>
                          }
                          <Link className="edit-btn" to={`/bank-accounts/create/${account.id}`}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              fill="none"
                              viewBox="0 0 16 17"
                            >
                              <path
                                stroke="#111"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13.536 6.296L6.112 13.72a2.667 2.667 0 01-1.886.78h-1.56A.666.666 0 012 13.834v-1.56a2.666 2.666 0 01.78-1.886l7.424-7.424a1.6 1.6 0 012.253 0l1.08 1.08a1.6 1.6 0 010 2.252zM9 4.17l3.333 3.334"
                              ></path>
                            </svg>
                          </Link>
                          <Button className="delete-btn"
                            disabled={bankAccountDelete.buttonDisable}
                            onClick={() => dispatch(bankAccountDeleteStart({ bank_account_id: account.id }))}>
                            {bankAccountDelete.buttonDisable && (account.id === bankAccountDelete.data.bank_account_id) ? <ButtonLoader /> : <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              fill="none"
                              viewBox="0 0 19 20"
                            >
                              <g
                                stroke="#FF6A6A"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                clipPath="url(#clip0_43_3597)"
                              >
                                <path d="M16.666 6.333H3.333M15 8.833l-.558 6.134A3.333 3.333 0 0111.108 18h-2.25a3.333 3.333 0 01-3.333-3.033L5 8.833M8.333 10.5V13M11.658 10.5V13M13.75 6.333h-7.5l.417-1.758A2.067 2.067 0 018.708 3h2.584a2.067 2.067 0 012.041 1.575l.417 1.758z"></path>
                              </g>
                              <defs>
                                <clipPath id="clip0_43_3597">
                                  <path
                                    fill="#fff"
                                    d="M0 0H19V19H0z"
                                    transform="translate(0 .5)"
                                  ></path>
                                </clipPath>
                              </defs>
                            </svg>}
                          </Button>
                        </div>
                      </div>
                      <div className="bank-account-list-body-sec">
                        <div className="bank-account-list-account-number-sec">
                          <h4>XXXX XXXX XXXX {account.account_number.slice(-4)}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="bank-account-list-footer-sec">
                      <div className="bank-account-list-ifsc-code-sec">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="none"
                          viewBox="0 0 21 21"
                        >
                          <path
                            stroke="#252525"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M2.833 18h15M4.517 10.5v5M10.342 10.5v5M16.184 10.5v5M3.417 6.05l5.358-2.675a3.492 3.492 0 013.15 0l5.35 2.667A1.033 1.033 0 0116.817 8H3.875a1.025 1.025 0 01-.458-1.95z"
                          ></path>
                        </svg>
                        <span>{account.ifsc_code}</span>
                      </div>
                      <div className="bank-account-list-type-sec">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 16 17"
                        >
                          <path
                            stroke="#252525"
                            strokeLinecap="round"
                            strokeWidth="2"
                            d="M1.333 15.813V15a4.875 4.875 0 014.875-4.875h3.25A4.875 4.875 0 0114.333 15v.813M7.833 7.688a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5z"
                          ></path>
                        </svg>
                        <span>{account.account_type.charAt(0).toUpperCase() + account.account_type.slice(1)} {t("account")}</span>
                      </div>
                    </div>
                  </div>
                ))
                :
                <React.Fragment>
                  <div></div>
                  <NoDataFound />
                </React.Fragment>}
            </React.Fragment>
          ) : null}

        </div>
      </div>
    </>
  );
};

export default BankAccountIndex;
